export default __webpack_public_path__ + "static/media/go4pets.7a92e2f0.png";